import { useEffect } from 'react';

/**
 * Loads the GoHighLevel (LeadConnector) chat widget.
 *
 * IMPORTANT: React does NOT execute <script> tags rendered through JSX — the
 * browser inserts them into the DOM but never runs them, so the previous
 * `return <script ... />` approach mounted the tag yet the widget never loaded.
 *
 * We instead inject the script imperatively via the DOM after mount, which is
 * exactly what pasting the snippet into the page <body> does. A guard keeps it
 * from loading twice (React StrictMode double-invokes effects in dev).
 */
const WIDGET_ID = '6a776fd3e425d99b0624883b';
const LOADER_SRC = 'https://widgets.leadconnectorhq.com/loader.js';
export function GHLWidget() {
  useEffect(() => {
    // Already present? Do nothing.
    if (document.querySelector(`script[data-widget-id="${WIDGET_ID}"]`)) {
      return;
    }
    const script = document.createElement('script');
    script.src = LOADER_SRC;
    script.async = true;
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', WIDGET_ID);
    script.setAttribute('data-source', 'WEB_USER');
    document.body.appendChild(script);
  }, []);
  return null;
}